import { DocumentReviewLayout } from '~/widgets/document-review-layout'
import { EobProcessingContent } from './eob-processing-content'
import { EobProgressTrackerActions } from './eob-progress-tracker-actions'

/**
 * EOB Processing page — final EOB step. Shows Payment Summary and Patient Claim Data
 * tabs inside DocumentReviewLayout with progress tracking and validation.
 *
 * This is a `page/` because it's a route component for `/documents/:documentKey/eob-processing`.
 */
export function DocumentEobProcessingPage() {
  return (
    <DocumentReviewLayout
      step="EOB Processing"
      actions={<EobProgressTrackerActions />}
      customScroll
    >
      <EobProcessingContent />
    </DocumentReviewLayout>
  )
}
